// extracted by mini-css-extract-plugin
module.exports = {"viewport":"ZQLjoDPM22+pgU12FoFetQ=="};